<template>
  <div class="info-item" :class="{ 'is-edit': mode === 'edit' }">
    <div class="left" v-if="!data.isHideTitle">
      <div class="title">
        <text-box
          type="editor"
          :mode="mode"
          :image-style="{ height: '22px' }"
          :value="data.title || '标题'"
          @onChange="value => handleTitleChange(value)"
        >
          {{ data.title || "标题" }}
        </text-box>
      </div>
    </div>
    <div class="right" v-if="!data.isHideContent">
      <draggable
        class="content"
        v-model="contentList"
        :animation="200"
        :disabled="mode !== 'edit'"
        :group="'materialInfoContentList'"
        :ghostClass="'ghost'"
        :handle="'.edit-drag'"
        @start="dragContent = true"
        @end="dragContent = false"
        @change="handleSortContentList"
      >
        <template v-if="contentList && contentList.length > 0">
          <div class="content-item" v-for="(cItem, cIndex) in contentList" :key="cItem.key">
            <text-box
              type="editor"
              :mode="mode"
              :includeBtns="['drag', 'confirm', 'edit', 'delete', 'add']"
              :image-style="{ height: '68px' }"
              :value="cItem.data || '内容'"
              @onAdd="handleAddContentItem(cIndex)"
              @onDelete="handleContentItemDelete(cIndex)"
              @onChange="value => handleContentItemChange(cIndex, value)"
            >
              {{ cItem.data || "内容" }}
            </text-box>
          </div>
        </template>
        <template v-else-if="mode === 'edit'">
          <button class="add-btn" @click.stop="handleAddContentItem(0)">
            <i class="icon wiki-editable-add"></i>
          </button>
        </template>
      </draggable>
    </div>
    <div class="edit-btns-wrapper" v-if="mode == 'edit'">
      <edit-btns
        :edit-btns="['drag', 'setup', 'delete', 'add']"
        @onSetup="handleListItemSetup"
        @onDelete="handleListItemDelete"
        @onAdd="handleAddListInfo"
      ></edit-btns>
    </div>
    <!-- 设置 -->
    <setup-panel v-if="mode === 'edit'" ref="setupPanel" :data="data" @onChange="handleItemSetup"></setup-panel>
  </div>
</template>

<script>
import draggable from "vuedraggable";
// components
import TextBox from "../../../../components/TextBox";
import SetupPanel from "./SetupPanel";
import EditBtns from "../../../../components/EditBtns";

export default {
  name: "InfoBox",
  components: {
    draggable,
    TextBox,
    SetupPanel,
    EditBtns
  },
  props: {
    mode: String,
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dragContent: false,
      contentList: []
    };
  },
  watch: {
    data: {
      handler(val) {
        this.contentList = val.content;
      },
      immediate: true
    }
  },
  mounted() {},

  methods: {
    // 设置item
    handleListItemSetup() {
      this.$refs.setupPanel.open();
    },
    handleItemSetup(data) {
      this.$emit("onChange", data);
    },
    // 添加item
    handleAddListInfo() {
      this.$emit("onAdd");
    },
    // 删除item
    handleListItemDelete() {
      this.$emit("onDelete");
    },
    // 标题 change
    handleTitleChange(title) {
      const data = JSON.parse(JSON.stringify(this.data));
      data.title = title;
      this.$emit("onChange", data);
    },
    // 列表排序
    handleSortContentList() {
      const data = JSON.parse(JSON.stringify(this.data));
      data.content = this.contentList;
      this.$emit("onChange", data);
    },
    // 内容 item 添加
    handleAddContentItem(index = 0) {
      const data = JSON.parse(JSON.stringify(this.data));
      data.content.splice(index + 1, 0, {
        key: Math.random().toString(16),
        data: ""
      });
      this.$emit("onChange", data);
    },
    // 内容 item 删除
    handleContentItemDelete(index = 0) {
      const data = JSON.parse(JSON.stringify(this.data));
      data.content.splice(index, 1);
      this.$emit("onChange", data);
    },
    // 内容Item change
    handleContentItemChange(index, value) {
      const data = JSON.parse(JSON.stringify(this.data));
      data.content.splice(index, 1, {
        key: data.key,
        data: value
      });
      this.$emit("onChange", data);
    }
  }
};
</script>

<style lang="less" scoped>
.is-edit {
  &:hover {
    outline: #c7ccd5;
    outline-style: solid;
    outline-width: 3px;
    .edit-btns-wrapper {
      display: inline-flex;
    }
  }
}
.edit-btns-wrapper {
  display: none;
  position: absolute;
  box-sizing: content-box;
  height: 20px;
  right: -92px;
  top: 0;
  padding-bottom: 3px;
}

.add-btn {
  width: 20px;
  height: 20px;
  color: #ffffff;
  border-radius: 4px;
  margin-left: 3px;
  border: none;
  vertical-align: middle;
  line-height: 20px;
  text-align: center;
  &:hover {
    opacity: 0.9;
  }
  .icon {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
.info-item {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  .left {
    min-width: 60px;
    font-size: 20px;
    font-weight: bold;
    color: #373737;
    line-height: 22px;
  }
  .right {
    flex: 1;
    width: 100%;
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }
  .content-item {
    min-width: 68px;
    min-height: 22px;
    line-height: 22px;
  }
}
</style>
